import React from 'react';
import { useTranslation } from 'react-i18next';
import { s } from '../helpers';

export interface KeyIndicatorItem {
  label: string;
  valueText: string;
  prevText: string;
  tip: string;
  deltaText: string;
  deltaColor: string;
  arrow: string;
  statusLabel: string;
  statusColor: string;
  onClick?: () => void;
  tipOpen: boolean;
  onEnter: () => void;
  onLeave: () => void;
}

export interface KeyIndicatorsProps {
  kiSpan: string;
  keyInd: KeyIndicatorItem[];
}

export const KeyIndicators: React.FC<KeyIndicatorsProps> = ({ kiSpan, keyInd }) => {
  const { t } = useTranslation();

  return (
    <section
      style={s(
        `grid-column:${kiSpan};background:#FFFEFB;border:1px solid #EFE6D6;border-radius:12px;box-shadow:0 1px 3px rgba(120,90,30,0.06);padding:16px 18px;min-width:0;display:flex;flex-direction:column;gap:10px`
      )}
    >
      <div style={s(`display:flex;align-items:center;justify-content:space-between;gap:8px`)}>
        <h2
          style={s(
            `margin:0;font-size:14px;font-weight:700;color:#1B1B1B;text-transform:uppercase;letter-spacing:0.01em`
          )}
        >
          {t('managerNetwork.keyInd.title', 'Key Indicators')}
        </h2>
        <span style={s(`font-size:11.5px;color:#6B6358`)}>
          {t('managerNetwork.keyInd.realtime', 'Cập nhật real-time')}
        </span>
      </div>
      <div style={s(`display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:4px 12px`)}>
        {keyInd?.map((ki, ki_idx) => (
          <React.Fragment key={ki_idx}>
            <div
              onClick={ki.onClick}
              style={s(
                `position:relative;padding:6px 8px;border-radius:6px;display:flex;flex-direction:column;gap:2px;cursor:default;min-width:0`
              )}
            >
              <div style={s(`display:flex;align-items:center;gap:5px`)}>
                <span style={s(`font-size:11.5px;color:#3A342C;white-space:nowrap;overflow:hidden;text-overflow:ellipsis`)}>
                  {ki.label}
                </span>
                <span
                  onMouseEnter={ki.onEnter}
                  onMouseLeave={ki.onLeave}
                  style={s(`color:#CFC4B2;font-size:11px;cursor:help;display:flex`)}
                >
                  <i className="icon-info"></i>
                </span>
              </div>
              <div style={s(`display:flex;align-items:center;gap:6px`)}>
                <span style={s(`font-size:18px;font-weight:700;color:#1B1B1B`)}>{ki.valueText}</span>
                <span
                  title={ki.statusLabel}
                  style={s(`width:7px;height:7px;border-radius:50%;background:${ki.statusColor}`)}
                ></span>
              </div>
              <span
                title={t('managerNetwork.keyInd.prevPeriod', 'Kỳ trước: {{val}}', { val: ki.prevText })}
                style={s(`display:flex;align-items:center;gap:3px;color:${ki.deltaColor};font-weight:600;font-size:11px`)}
              >
                <i className={`icon-${ki.arrow}`} style={s(`font-size:10px`)}></i>
                {ki.deltaText}
              </span>
              {Boolean(ki.tipOpen) && (
                <div
                  style={s(
                    `position:absolute;top:26px;left:6px;width:220px;z-index:20;background:#2A2419;color:#fff;font-size:12px;line-height:1.45;padding:10px 12px;border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,0.2)`
                  )}
                >
                  {ki.tip}
                </div>
              )}
            </div>
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};
